/**
 * Local stub config provider for CO0 dev boots.
 * TODO(CO1): remove from production bundle; replace with control-plane fetch.
 */

import type { CompanionSiteConfig, CompanionSiteKey } from './types';
import {
  DEFAULT_COMPANION_PROACTIVE_CAPS,
  DEFAULT_COMPANION_TRANSCRIPT_RETENTION
} from './types';
import { parseCompanionSiteKey } from './siteKey';

export function createStubCompanionSiteConfig(siteKey: CompanionSiteKey): CompanionSiteConfig {
  const parsed = parseCompanionSiteKey(siteKey);
  const tenantId = parsed?.tenantId || 'stub-tenant';

  return {
    siteKey,
    tenantId,
    siteName: 'Camlin Companion (stub)',
    knowledgeSources: [
      { kind: 'sitemap', value: 'https://nuamedia.com.au/sitemap.xml', label: 'Nuamedia sitemap' }
    ],
    persona: {
      displayName: 'Camlin Guide',
      specialistPrompt:
        'You are the Camlin Companion — a warm product guide on this website. Answer from site knowledge; never invent pricing or policies.'
    },
    avatar: {
      modelId: 'cara',
      voiceId: 'en-AU-NatashaNeural',
      position: 'bottom-right',
      theme: 'auto'
    },
    allowedOrigins: ['https://nuamedia.com.au', 'http://localhost:3000'],
    allowedActionIds: ['book-demo', 'open-contact-modal'],
    actionRiskOverrides: [],
    proactive: {
      caps: { ...DEFAULT_COMPANION_PROACTIVE_CAPS },
      triggers: [
        {
          kind: 'page_dwell',
          match: '/connect',
          dwellSeconds: 45,
          nudgeMessage: 'Want a hand exploring Camlin Connect?'
        }
      ]
    },
    transcriptRetention: { ...DEFAULT_COMPANION_TRANSCRIPT_RETENTION },
    manifestPack: {
      version: 1,
      sections: [
        { id: 'pricing', label: 'Pricing', description: 'Platform pricing overview' },
        { id: 'contact-form', label: 'Contact form', description: 'Book a demo or consultation' }
      ],
      actions: [
        {
          id: 'book-demo',
          label: 'Book a demo',
          description: 'Opens the enterprise contact modal with demo interest pre-selected',
          sectionId: 'contact-form',
          risk: 'mutating'
        }
      ],
      fields: [
        { id: 'contact.email', label: 'Email', inputType: 'email' },
        { id: 'contact.firstName', label: 'First name', inputType: 'text' }
      ]
    }
  };
}
